export default __webpack_public_path__ + "static/media/listmenu.4c23cc84.svg";